import { render } from "./CircleAvatar.vue?vue&type=template&id=553994ba&scoped=true"
import script from "./CircleAvatar.vue?vue&type=script&lang=js"
export * from "./CircleAvatar.vue?vue&type=script&lang=js"

import "./CircleAvatar.vue?vue&type=style&index=0&id=553994ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553994ba"]])

export default __exports__